import React from "react";
import { useTranslation } from "react-i18next";

const PRESETS = [
  { key: "today", label: "today" },
  { key: "thisWeek", label: "thisWeek" },
  { key: "thisMonth", label: "thisMonth" },
  { key: "last3Months", label: "last3Months" },
  { key: "thisYear", label: "thisYear" },
];

function getPresetDates(key) {
  const now = new Date();
  const today = now.toISOString().slice(0, 10);
  switch (key) {
    case "today":
      return { start: today, end: today };
    case "thisWeek": {
      const day = now.getDay();
      const diff = day === 0 ? 6 : day - 1;
      const monday = new Date(now);
      monday.setDate(now.getDate() - diff);
      return { start: monday.toISOString().slice(0, 10), end: today };
    }
    case "thisMonth": {
      const first = new Date(now.getFullYear(), now.getMonth(), 1);
      return { start: first.toISOString().slice(0, 10), end: today };
    }
    case "last3Months": {
      const d = new Date(now);
      d.setMonth(d.getMonth() - 3);
      return { start: d.toISOString().slice(0, 10), end: today };
    }
    case "thisYear": {
      return { start: `${now.getFullYear()}-01-01`, end: today };
    }
    case "allTime": {
      return { start: "2010-01-01", end: today };
    }
    default:
      return { start: today, end: today };
  }
}

const DateRangeFilter = ({ startDate, endDate, setStartDate, setEndDate, showAllTime }) => {
  const { t } = useTranslation();

  const presets = showAllTime
    ? [...PRESETS, { key: "allTime", label: "allTime" }]
    : PRESETS;

  const handlePreset = (key) => {
    const { start, end } = getPresetDates(key);
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      {presets.map((preset) => (
        <button
          key={preset.key}
          className="btn btn-sm btn-outline-primary"
          onClick={() => handlePreset(preset.key)}
          style={{ fontSize: "12px" }}
        >
          {t(preset.label)}
        </button>
      ))}
      <div className="d-flex align-items-center gap-1 ms-2">
        <label style={{ fontSize: "12px", whiteSpace: "nowrap" }}>{t("from")}:</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          style={{ maxWidth: "150px", fontSize: "12px" }}
        />
        <label style={{ fontSize: "12px", whiteSpace: "nowrap" }}>{t("to")}:</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          style={{ maxWidth: "150px", fontSize: "12px" }}
        />
      </div>
    </div>
  );
};

export default DateRangeFilter;
